module.exports = __webpack_public_path__ + "static/riobamba-93f1229327e228506cea43d6de0d1b72.jpg";